import React, { FC } from 'react'
import { CenteredContentLayout, Icon, IconButton, VStack } from '../components'
import { FindPlanFormSteps } from './blocks'
import { previousStep, selectHasPreviousStep, useDispatch, useSelector } from '../state'
import { ScenarioCancel } from '../components/scenario-cancel'
import { useDropOutAnalytics } from '../analytics'

// @todo: This guy is currently untested
export const FindPlanMultistepForm: FC = () => {
  const dispatch = useDispatch()
  const hasPreviousStep = useSelector(selectHasPreviousStep)

  useDropOutAnalytics()

  return (
    <>
      <CenteredContentLayout
        headerRight={
          <>
            <ScenarioCancel />
          </>
        }
        headerLeft={
          hasPreviousStep && (
            <IconButton
              label="Back"
              size="3xl"
              icon={<Icon icon="arrow-left-circle" color="green.500" />}
              onClick={() => dispatch(previousStep())}
            />
          )
        }
      >
        <VStack spacing="6" alignItems="stretch">
          <FindPlanFormSteps />
        </VStack>
      </CenteredContentLayout>
    </>
  )
}
